import { MerchandiseShippingOrderCreationItem } from 'api/order'
import getMerchandiseShippingItemViews from 'checkout/selectors/view/itemViews/getMerchandiseShippingItemViews'
import { nonNullable } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'

const getFormattedMerchandiseShippingItems = createSelector(
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (state: App.State) => state.destination.googlePlaces[state.checkout.form.deliveryForm.addressPlaceId ?? ''],
  (state: App.State) => state.checkout.form.deliveryForm,
  (views, address, form): Array<MerchandiseShippingOrderCreationItem> => {
    const items = views.data.map((view): MerchandiseShippingOrderCreationItem | undefined => {
      if (!form.phoneNumber ||
        !form.firstName ||
        !form.lastName ||
        !address
      ) {
        // doesn't have the necessary fields
        return undefined
      }

      return {
        type: 'merchandise_shipping',
        transaction_key: view.item.transactionKey,
        total: view.totals.otherFees?.deliveryFee ?? 0,
        shippingGroup: view.item.shippingId,
        address: {
          firstName: form.firstName,
          lastName: form.lastName,
          company: form.company,
          country: form.country ?? 'Australia',
          phone: `+${form.phoneNumber.prefix}${form.phoneNumber.phone}`,
          address: address.addressDetails.streetAddress,
          // Prefer unit number from Google autocomplete, fallback to manual form input
          address2: address.addressDetails.unitNumber ?? form.unitNumber ?? undefined,
          city: address.addressDetails.city,
          state: address.addressDetails.state,
          postcode: address.addressDetails.postcode,
        },
      }
    })

    return nonNullable(items)
  }
)

export default getFormattedMerchandiseShippingItems
